import { inject, signal } from '@angular/core';
import { AppStateService, AuthenticationService, HttpErrorService, StationsService } from '../../../services';
import { PublicRoutes } from '../../../enums';
import { StationGroup } from '../../../models';
import { Router } from '@angular/router';

/** when extending this class be sure to implement ngOnInit */
export abstract class NgxAimViewStationGroupsClass {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);
  httpErrorService = inject(HttpErrorService);
  appStateService = inject(AppStateService);
  authService = inject(AuthenticationService);
  router = inject(Router);

  groups: StationGroup[] = [];
  locations = this.appStateService.getLocations();
  selectedLocation = this.appStateService.getDefaultLocation();
  isLoading = signal(true);
  routes = PublicRoutes;

  init() {
    if (!this.authService.getCurrentUser() && this.appStateService.isBrowser) {
      this.router.navigate(['/', PublicRoutes.SIGN_IN], {
        queryParams: { returnUrl: `/${PublicRoutes.STATIONS}/${PublicRoutes.GROUPS}` }
      });
    } else {
      this.findAllStationGroups();
    }

    if (this.appStateService.isBrowser) {
      this.stationsService.setSelectedLocation(this.selectedLocation);
    }
  }

  findAllStationGroups() {
    this.isLoading.set(true);
    this.stationsService.findAllStationGroups(this.selectedLocation.Id).subscribe({
      next: (groups) => this.onGroupSuccess(groups),
      error: (err) => this.onGroupError(err),
    });
  }

  onGroupSuccess(groups: StationGroup[]) {
    this.isLoading.set(false);
    this.groups = groups;
  }

  onGroupError(err: any) {
    this.isLoading.set(false);
    this.httpErrorService.onHttpError(err, 'Could not load station groups');
  }

  onLocationChange() {
    this.stationsService.reset();
    this.findAllStationGroups();
    this.stationsService.setSelectedLocation(this.selectedLocation);
  }

  onGroupClick(group: StationGroup) {
    this.stationsService.setSelectedGroup(group);
  }
}
